import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// De-dupe rapid identical events (form typing on every keystroke etc.).
const recent = new Map();  // key -> ts
const DEDUPE_MS = 15_000;

/**
 * Fire-and-forget cart telemetry.
 * type: "add_to_cart" | "clicked_checkout"
 * data: { email, product_id, quantity, first_name?, last_name?, aud_variant?, referral? }
 */
export function trackCart(type, data) {
  const email = (data?.email || "").trim().toLowerCase();
  if (!email || !email.includes("@")) return;   // no email -> no track
  const key = `${type}:${email}:${data?.product_id || ""}`;
  const now = Date.now();
  const prev = recent.get(key);
  if (prev && now - prev < DEDUPE_MS) return;   // silently drop repeats
  recent.set(key, now);
  const payload = {
    type,
    email,
    product_id: (data?.product_id || "").toString(),
    quantity: parseInt(data?.quantity || 1, 10) || 1,
    first_name: (data?.first_name || "").trim(),
    last_name: (data?.last_name || "").trim(),
    aud_variant: (data?.aud_variant || "").trim(),
    referral: (data?.referral || "").trim(),
  };
  // Fire-and-forget; never block the UI.
  axios.post(`${API}/cart/track`, payload).catch(() => { /* silent */ });
}
